

























import Vue from "vue";
import { Component } from "vue-property-decorator";
import FilterComponent from './ProposalCallsFilter/Filter/Filter.vue';
import ProposalCallsFilterComponent from './ProposalCallsFilter/ProposalCallsFilter.vue';
import ProposalGridComponent from './ProposalCallsFilter/ProposalGrid.vue';
import { AppConstants as _app } from "@/shared/app.constants";
import { http } from "@/shared/https";
import { Utilities as utils } from "@/shared/utilities";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import { ReportFilter, ReportParameter } from "@/entities";
import { Locales } from "@/i18n/locales";

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";

@Component({
  components: {
    ProposalCallsFilterComponent,
    ProposalGridComponent,
    FilterComponent,
    AdvanceSearchComponent
  }
})
export default class ApplicantDashboardComponent extends Vue {
  isTabView: boolean = false;
  collapsed = false;
  item: Array<any> = [];
  items: Array<any> = [];
  filterKey: any;
  filters: Array<any> = [];
  selectedParams: Array<ReportParameter> = [];
  tabs = [
    { component: "ProposalCallsFilterComponent", text: "Grid View", icon: "mdi-format-list-bulleted-square" },
    { component: "ProposalGridComponent", text: "Card View", icon: "mdi-view-grid" }
  ];
  currentTab = this.tabs[0];
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {
    const self = this;
    self.listProposal().then((resp: any) => {
      if (resp && resp.length > 0) {
        self.items = resp.map(x => {
          x.TotalProjectBudget = x.TotalProjectBudget ? utils.formatCurrency(x.TotalProjectBudget, x.BudgetCurrency, this.defaultLocale) : "";
          x.RequestedAmount = x.RequestedAmount ? utils.formatCurrency(x.RequestedAmount, x.BudgetCurrency, this.defaultLocale) : "";
          return x;
        });
      }
    });
    self.getFilters();
    self.getLeftPanelFilter();
  }

  getLeftPanelFilter(){
    http.get(`api/Proposal/GetFilter`).then((resp: any) => {
      if (resp.status >= 200 && resp.status < 300) {
        this.item = resp.data.Result;
      }
    });    
  }

  collapseFilter() {
    this.collapsed = !this.collapsed;
  }

  addNewProposal() {
    this.$router.push({
      name: "callForProposal"
    });
  }

  get currentTabComponent() {
    return this.currentTab.component;
  }

  getFilters() {
    http.get(`/api/Proposal/AdvanceFilter`).then((resp: any) => {
      if (resp.status >= 200 && resp.status < 300 && resp.data) {
        this.filters = resp.data;
      }
    });
  }

  rollback(appInfo) {
    this.listProposal().then((resp: any) => {
      if (resp && resp.length > 0) {
        this.items = resp.map(x => {
          x.TotalProjectBudget = x.TotalProjectBudget ? utils.formatCurrency(x.TotalProjectBudget, x.BudgetCurrency, this.defaultLocale) : "";
          x.RequestedAmount = x.RequestedAmount ? utils.formatCurrency(x.RequestedAmount, x.BudgetCurrency, this.defaultLocale) : "";
          return x;
        });
      }
    });
  }

  onSearch() {
    http.post(`/api/Proposal/application/Filter`, this.selectedParams)
      .then((resp: any) => {
        if (resp.status >= 200 && resp.status < 300) {
          this.items = resp.data.Items.map(x => {
            x.TotalProjectBudget = x.TotalProjectBudget ? utils.formatCurrency(x.TotalProjectBudget, x.BudgetCurrency, this.defaultLocale) : "";
            x.RequestedAmount = x.RequestedAmount ? utils.formatCurrency(x.RequestedAmount, x.BudgetCurrency, this.defaultLocale) : "";
            return x;
          }) || [];
        }
      });
  }

  switchLayout(isTabView) {
    this.isTabView = !isTabView;

    if (this.isTabView) {
      this.currentTab = this.tabs[1];
    } else {
      this.currentTab = this.tabs[0];
    }
  }

  removeItem(data) {
    const self = this;
    const id = (typeof data.ApplicationId == "string") ? parseInt(data.ApplicationId) : data.ApplicationId;
    if (confirm("Are you sure to delete this application?")) {
      self.$services.application.deleteApplication(id).then((data: any) => {
        if (data.Result === "OK") {
          self.callFilter(self.filterKey);
        }
      });
    }
  }

  listProposal() {
    return http.get(`/api/Proposal/application/List`).then((resp: any) => {
      return resp.data.Items;
    });
  }

  callFilter(e) {
    let filteredData = '';
    const self = this;
    self.filterKey = e;
    http.get(`/api/Proposal/application/List?${e}`).then((resp: any) => {
      // self.items = resp.data.Items;
      if (resp && resp.data.Items && resp.data.Items.length > -1) {
        self.items = resp.data.Items.map(x => {
          x.TotalProjectBudget = utils.formatCurrency(x.TotalProjectBudget, x.BudgetCurrency, this.defaultLocale);
          x.RequestedAmount = utils.formatCurrency(x.RequestedAmount, x.BudgetCurrency, this.defaultLocale);
          return x;
        });
      }
      if(resp.data.Filters != null){
        filteredData = JSON.stringify(resp.data.Filters);
      }      
      let initialFilter = JSON.stringify(self.item);
      if(filteredData && filteredData !== initialFilter){
        self.item = resp.data.Filters;
      }
    });
  }
}
